// extracted by mini-css-extract-plugin
export default {"box":"loginPage_box__z0j8V","box__form":"loginPage_box__form__m1mli"};